import React from 'react';
import styled, { css } from 'styled-components';
import NewPaginationPerPage from '../../app/components/pagination/NewPaginationPerPage';
import ProductListViewCard from './ProductListViewCard';
import StyledText from '../../app/components/styledComponents/StyledText';
import StyledCheckbox from '../../app/components/checkbox/StyledCheckbox';

const ProductListView = ({
  data,
  deleteProduct,
  onRefetch,
  action,
  selectedProducts,
  handleProductSelection,
  loading,
  isSelectProduct,
  isComingFromEditTemplate,
  onHandleButtonActionForTemplate,
  serProductEditId,
  isCatalogue,
  handleBulkEditTopTags,
  isProduct,
  setUpdatingTag,
  changeInPageNumber = false,
  catalogLoading,
  setShowDeleteConfirmation,
  handleAllProductsSelection,
  products,
  ...props
}) => {
  return (
    <>
      {selectedProducts?.length > 0 && (
        <StyledSpan
          active={products?.objectData?.content?.every(({ id }) =>
            selectedProducts?.includes(id),
          )}
          className="d-flex flex-row align-items-center p-2 mb-3"
        >
          <StyledCheckbox
            style={{ display: 'inline-flex' }}
            borderColor={'gray40'}
            bgColor={'primary'}
            value={products?.objectData?.content?.every(({ id }) =>
              selectedProducts?.includes(id),
            )}
            onChange={(e) => handleAllProductsSelection(e.target.checked)}
          />
          <StyledText
            className="ms-1"
            style={{ marginBottom: 0 }}
            color={'bodyMedium'}
            $fontSize={'16px'}
          >
            Select All
          </StyledText>
        </StyledSpan>
      )}
      <ProductGridContainer>
        {data?.content.map((item, index) => (
          <ProductListViewCard
            selectedProducts={selectedProducts}
            handleProductSelection={handleProductSelection}
            product={item}
            setUpdatingTag={setUpdatingTag}
            key={`product-card-${item.id}`}
            deleteProduct={deleteProduct}
            refetch={onRefetch}
            isCatalogue={isCatalogue}
            handleBulkEditTopTags={handleBulkEditTopTags}
            isSelectProduct={isSelectProduct}
            isComingFromEditTemplate={isComingFromEditTemplate}
            onHandleButtonActionForTemplate={onHandleButtonActionForTemplate}
            serProductEditId={serProductEditId}
            isProduct={isProduct}
            catalogLoading={catalogLoading}
            setShowDeleteConfirmation={setShowDeleteConfirmation}
            {...props}
          />
        ))}
      </ProductGridContainer>
      {(!data || data?.length < 1) && !loading && (
        <StyledText
          as="h4"
          $fontSize="28px"
          className="d-flex align-items-center justify-content-center my-3 my-md-5"
        >
          No Data Found
        </StyledText>
      )}
      {!(!data || data?.length < 1) && (
        <div className="p-2 p-md-4">
          <NewPaginationPerPage
            paginationData={data || {}}
            onPerPageChange={action?.handlePerPageChange}
            onPageChange={action?.handlePageChange}
            onRefetch={onRefetch}
            changeInPageNumber={changeInPageNumber}
          />
        </div>
      )}
    </>
  );
};

const ProductGridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(721px, 1fr));
  ${({ theme }) => css`
    @media (max-width: ${theme?.breakpoints?.md}px) {
      grid-template-columns: repeat(auto-fill, minmax(100%, 1fr));
    }
  `}
  gap: 30px;
`;

const StyledSpan = styled.span`
  border: ${({ active, theme }) =>
    active ? `1px solid ${theme.primary}` : '1px solid #03022969'};
  display: inline-block;
  width: 125px !important;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 0.5rem; /* equivalent to Bootstrap p-2 */
  margin-bottom: 1rem; /* equivalent to mb-3 */
`;

export default ProductListView;
